import Vue from 'vue'
import Vuex from 'vuex'
import App from "./App.vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from "./router";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import VueQrcode from '@chenfengyuan/vue-qrcode';

import DateRangePicker from 'vue2-daterange-picker'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

import VueSession from 'vue-session'
import Multiselect from 'vue-multiselect'
import env from './env'
import msg from './message'

import JsonExcel from "vue-json-excel";
import VueMoment from "vue-moment"
import i18n from './i18n'
import FlagIcon from 'vue-flag-icon'

import ("./assets/css/vendors.bundle.css");
import ("./assets/css/app.bundle.css");
import ("./assets/css//dashboard/dashboard.css");
import ("./assets/css/datagrid/datatables.bundle.css");
import ("./assets/css/font-awesome/fa-solid.css");
import ("./assets/css/font-awesome/fa-regular.css");
import ("./assets/css/font-awesome/fa-brands.css");
import ("./assets/css/bootstrap-side-modals.css")


import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import 'vue-search-select/dist/VueSearchSelect.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import store from './store'

import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import UUID from "vue-uuid";

import exportCSV from './components/Export_CSV'
 


Vue.config.productionTip = false
axios.defaults.baseURL = env.API_ENDPOINT;
Vue.prototype.$axios = axios
Vue.prototype.$api = env
Vue.prototype.$msg = msg
Vue.prototype.$window = window
Vue.prototype.$util = {
  getSessionToken() {
    return localStorage.getItem('token')
  }
}

Vue.use(FlagIcon);
Vue.use(VueMoment);
Vue.use(VueAxios, axios)
Vue.use(Vuex)
Vue.use(VueSession)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueNumberInput)
Vue.component(VueQrcode.name, VueQrcode);
Vue.use(DateRangePicker)
Vue.component(VueCropper);
Vue.component('multiselect', Multiselect)
Vue.use(VueLodash, {lodash: lodash })
// Vue.component("exportCSV", JsonExcel);
Vue.component("exportCSV", exportCSV);
Vue.use(UUID);

Chart.plugins.unregister(ChartDataLabels);

new Vue({
  render: h => h(App),
  router,
  store, 
  i18n,
}).$mount('#app')


